import { Navigate, Outlet, useLocation } from 'react-router'

import { useAuth } from '../session/auth-context'

/** Layout route for pages that require a signed-in user. */
export function RequireAuth() {
  const { isAuthenticated } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    // Visitors hitting the site root see the public landing page first;
    // deep links still go straight to sign-in and return afterwards.
    if (location.pathname === '/') return <Navigate to="/welcome" replace />
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  }
  return <Outlet />
}

/** Layout route for auth pages that make no sense once signed in. */
export function RedirectIfAuthenticated() {
  const { isAuthenticated } = useAuth()

  if (isAuthenticated) return <Navigate to="/" replace />
  return <Outlet />
}
